/**
 * ThemeSync Bridge Component
 *
 * Bridges the gap between ThemeProvider (above QueryClientProvider) and
 * the user-preferences API (requires React Query). Reads the stored theme
 * preference and pushes it into ThemeProvider whenever it changes.
 */

import { useEffect } from 'react';
import { useTheme } from '@/shared/components/context/theme-provider';
import { useThemePreference } from '@/shared/hooks/use-user-preferences';

export function ThemeSync() {
  const storedTheme = useThemePreference();
  const { theme, setTheme } = useTheme();

  useEffect(() => {
    if (storedTheme !== theme) {
      setTheme(storedTheme);
    }
  }, [storedTheme]); // eslint-disable-line react-hooks/exhaustive-deps -- intentionally only re-run on preference change

  return null;
}
